import {configurationActionTypes} from "../constants/ActionTypes";

const initialState = {
  configurations: null
};

const configurations = (state = initialState, action) => {
  switch (action.type) {
    case configurationActionTypes.GET_LIST:
      return {
        ...state,
        configurations: action.configurations
      };
    case configurationActionTypes.SAVE:
      return {
        ...state,
        configurations: {
          ...state.configurations,
          [action.configuration.config_group]: {
            ...state.configurations[action.configuration.config_group],
            [action.configuration.config_key]: {
              ...state.configurations[action.configuration.config_group][action.configuration.config_key],
              ...action.data
            }
          }
        }
      };
  }

  return state;
};

export default configurations;



// WEBPACK FOOTER //
// ./reducers/configuration.reducers.js